module.exports = __webpack_public_path__ + "static/media/dateformat.3b324463.svg";